import React from 'react';
import '../App.css';
import cfl from '../config.json';
import $ from 'jquery';
import config from '.././config.json';
import moment from 'moment';
import DatePickerDropdown from '.././Registration/DatePickerDropdown';
import { Redirect } from 'react-router';
import LoginForm from '../LoginForm.js';
import usStates from '../usStates';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import {
    Form, Input, Tooltip, Icon, Select,
    Button, DatePicker, InputNumber, Spin, notification
} from 'antd';
const { RangePicker } = DatePicker;
const FormItem = Form.Item;
const Option = Select.Option;

const shortFormItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 4 },
        sm: { span: 3 },
    },
};

const midFormItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 12 },
        sm: { span: 8 },
    },
};

class EditStudentForm extends React.Component {
    formVariables = [{ FirstName: '' }, { MiddleInitial: '' }, { LastName: '' }, { DLN: '' }, { DateofBirth: '' }, { StreetAddress: '' }, { State: '' }, { City: '' },
    { ZipCode: '' }, { PhoneNumber: '' }, { Email: '' }, { TechID: '' }];

    constructor(props) {
        super(props);
        this.stateList = usStates.listofUSstates();
        //Set the form variables
        this.props.form.validateFieldsAndScroll((err, values) => {
            this.formVariables.FirstName = values.fname;
            this.formVariables.MiddleInitial = values.lname;
            this.formVariables.LastName = values.mname;
            this.formVariables.DLN = values.dln;
            this.formVariables.DateofBirth = values.dob;
            this.formVariables.StreetAddress = values.street;
            this.formVariables.State = values.state;
            this.formVariables.City = values.city;
            this.formVariables.ZipCode = values.zipcode;
            this.formVariables.PhoneNumber = values.phone;
            this.formVariables.Email = values.email;
            this.formVariables.TechID = values.TechID;
        });

        this.state = {
            loading: false,
            login: true,
            validTechID: true,
            id: null,
            name: null
        };

        this.employerDisplayList = [];
        $.ajax({
            type: 'POST',
            url: `${config.serverUrl}/api/registration/getallemployer`,
        })
            .done((data) => {
                for (let i = 0; i < data.length; i++) {
                    var optDis = data[i].CompanyName + ", " + data[i].City + " (" + data[i].State + ")";
                    this.employerDisplayList.push(
                        <Option key={data[i].Id} value={data[i].Id.toString()}>{optDis}</Option>
                    );
                }
            })
            .fail((jqXhr) => {
                console.log('failed to get employer');
            });

    }

    componentDidMount() {
        this.setState({ loading: true });

        LoginForm.ValidateServerToken(
            () => { this.setState({ login: false }) }, //logout
            () => {
                if (typeof this.props.updateFields != 'undefined') {
                    this.formVariables.FirstName = this.props.updateFields.FirstName;
                    this.formVariables.MiddleInitial = this.props.updateFields.MiddleInitial;
                    this.formVariables.LastName = this.props.updateFields.LastName;
                    this.formVariables.DLN = this.props.updateFields.DLN;
                    this.formVariables.DateofBirth = moment(this.props.updateFields.DateofBirth);
                    this.formVariables.StreetAddress = this.props.updateFields.StreetAddress;
                    this.formVariables.State = this.props.updateFields.State;
                    this.formVariables.City = this.props.updateFields.City;
                    this.formVariables.ZipCode = this.props.updateFields.ZipCode;
                    this.formVariables.PhoneNumber = this.props.updateFields.PhoneNumber;
                    this.formVariables.Email = this.props.updateFields.Email;
                    this.formVariables.TechID = this.props.updateFields.TechID;
                    if (this.props.empData.Id != -1) {

                        var curemp = this.props.empData;
                        var empInfo = curemp.CompanyName + ", " + curemp.City + " (" + curemp.State + ")";
                        this.setState({
                            id: curemp.Id,
                            name: empInfo
                        })
                        this.currentEmployer = this.state.name;
                    }
                    else {
                        this.currentEmployer = "-1";
                    }
                }

                this.setState({ loading: false });
            }); //login
    }

    /**
    * Form submit event
    */
    handleSubmit = (e) => {
        if (this.state.validTechID == false) { alert("Invalid TechID"); } else {
            e.preventDefault();
            this.props.form.validateFieldsAndScroll((err, values) => {
                if (!err) {
                    //Format the data to be recieved by the server
                    var formObj = {
                        FirstName: values.fname,
                        LastName: values.lname,
                        MiddleInitial: values.mname,
                        DLN: values.dln,
                        DateofBirth: values.dob,
                        StreetAddress: values.street,
                        State: values.state,
                        City: values.city,
                        ZipCode: values.zipcode,
                        PhoneNumber: values.phone,
                        Email: values.email,
                        TechID: values.techID
                    }
                    formObj.Id = this.props.updateFields.Id;

                    if (this.state.id != -1) {

                        var stdEmpl = {

                            StudentId: formObj.Id,
                            EmployerId: this.state.id

                        }

                        this.ajaxCall('POST', '/api/students/updateStudentEmployee',
                            stdEmpl, (data) => {//success
                            }, () => {//fail
                            });

                    }
                    this.setState({ loading: true })
                    this.ajaxCall('POST', '/api/students/update',
                        formObj, (data) => {//success
                            this.props.form.resetFields();
                            this.setState({ loading: false })
                            this.props.updateEvent();
                        }, () => {//fail
                            this.openNotificationWithIcon('error', 'Failed To Edit', 'Connection to server may have been lost!')
                            this.setState({ loading: false })
                            console.log('failed to register');
                        });


                }
            });
        }
    }

    validateTechID(TechID) {
        console.log("Validating ID: " + TechID);
        this.state.validTechID = true;
        if (TechID == "") { this.state.validTechID = false; }
        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/students/getAllTechID`
        })
            .done((data) => {
                console.log('got the data!');
                //console.log(data);
                for (var i = 0; i < data.length; i++) {
                    if (data[i] == TechID) {
                        console.log(this.state.initialTechID);
                        if (data[i] == this.state.initialTechID) { break; }
                        alert("That TechID already exists!");
                        this.state.validTechID = false;
                    }
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                console.log('failed to validate TechID');
            });
    }

    /**
     * Used for custom ajax calls
     * @param {any} type
     * @param {any} url
     * @param {any} data
     * @param {any} done
     * @param {any} fail
     */
    ajaxCall(type, url, data, done, fail) {
        $.ajax({
            type: type,
            url: `${config.serverUrl}` + url,
            data: data
        })
            .done((data) => {
                done(data);
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                fail();
            });
    }

    /**
    * Opens the Notification window
    */
    openNotificationWithIcon = (type, title, body) => {
        notification[type]({
            message: title,
            description: body,
        });
    };

    /**
     * Render Function
     */
    render() {
        const { getFieldDecorator } = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 14 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 14,
                    offset: 6,
                },
            },
        };

        return (
            <div>
                {this.state.login ?
                    <Spin spinning={this.state.loading}>
                        <h2>Edit Student</h2>
                        <hr />
                        <Form onSubmit={this.handleSubmit}>

                            <div className='forms'>
                                {/*------------------------------------------ User Details ------------------------------------------*/}
                                <FormItem {...formItemLayout} label="First Name" >
                                    {getFieldDecorator('fname', {
                                        initialValue: this.formVariables.FirstName,
                                        rules: [{
                                            required: true, message: 'Please input your first name!',
                                        }],
                                    })(<Input />)}
                                </FormItem>
                                {/*TODO: Limit one character*/}
                                <FormItem {...shortFormItemLayout} label="Middle Initial" >
                                    {getFieldDecorator('mname', {
                                        initialValue: this.formVariables.MiddleInitial,
                                        rules: [],
                                    })(<Input />)}
                                </FormItem>
                                <FormItem {...formItemLayout} label="Last Name" >
                                    {getFieldDecorator('lname', {
                                        initialValue: this.formVariables.LastName,
                                        rules: [{
                                            required: true, message: 'Please input your last name!',
                                        }],
                                    })(<Input />)}
                                </FormItem>
                                <FormItem {...formItemLayout} label="Tech ID" >
                                    {getFieldDecorator('techID', {
                                        initialValue: this.formVariables.TechID,
                                        rules: [{
                                            required: true, message: 'Please enter a TechID',
                                        }],
                                    })(<Input onBlur={value => { this.validateTechID(value.currentTarget.value); }} />)}
                                </FormItem>
                                <FormItem
                                    {...formItemLayout} label="Date of Birth">
                                    {getFieldDecorator('dob', {
                                        initialValue: this.props.date,
                                    })(
                                        <DatePickerDropdown getDOBNew={this.getDateOfBirthNew} sendUserData={this.props.date} />
                                        //<DatePicker format={"MM-DD-YYYY"} onChange={this.onChange} />
                                    )}
                                </FormItem>
                                {/*------------------------------------------ ADDRESS ------------------------------------------*/}
                                <FormItem {...formItemLayout} label="Street" >
                                    {getFieldDecorator('street', {
                                        initialValue: this.formVariables.StreetAddress,
                                        rules: [{
                                            required: true, message: 'Please input street!',
                                        }],
                                    })(<Input />)}
                                </FormItem>
                                <FormItem {...formItemLayout} label="City" >
                                    {getFieldDecorator('city', {
                                        initialValue: this.formVariables.City,
                                        rules: [{
                                            required: true, message: 'City',
                                        }],
                                    })(<Input />)}
                                </FormItem>


                                <FormItem {...formItemLayout} label="State">
                                    {getFieldDecorator('state', {
                                        initialValue: this.formVariables.State,
                                        rules: [
                                            { required: true, message: 'Please select your country!' },
                                        ],
                                    })(
                                        <Select
                                            showSearch
                                            style={{ width: '40%' }}
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            {this.stateList}
                                        </Select>)}
                                </FormItem>



                                <FormItem {...midFormItemLayout} label="ZipCode">
                                    {getFieldDecorator('zipcode', {
                                        initialValue: this.formVariables.ZipCode,
                                        rules: [{ required: true, message: 'Please input your Zip Code!' }],
                                    })(
                                        <Input type="number" style={{ width: '100%' }} />
                                    )}
                                </FormItem>
                                {/*------------------------------------------ CONTACT ------------------------------------------*/}
                                <FormItem {...formItemLayout} label="Phone Number">
                                    {getFieldDecorator('phone', {
                                        initialValue: this.formVariables.PhoneNumber,
                                        rules: [{ required: true, message: 'Please input your phone number!' }],
                                    })(
                                        <Input style={{ width: '100%' }} />
                                    )}
                                </FormItem>
                                <FormItem
                                    {...formItemLayout} label="E-mail">
                                    {getFieldDecorator('email', {
                                        initialValue: this.formVariables.Email,
                                        rules: [{
                                            type: 'email', message: 'The input is not valid E-mail!',
                                        }, {
                                            required: true, message: 'Please input your E-mail!',
                                        },
                                        {
                                            validator: this.checkConfirm,
                                        }],
                                    })(
                                        <Input />
                                    )}
                                </FormItem>
                                {/*
                            <FormItem
                                {...formItemLayout} label="E-mail Confirm" >
                                {getFieldDecorator('emailConfirm', {
                                    initialValue: this.formVariables.Email,
                                    rules: [{
                                        required: true, message: 'Please confirm your E-mail!'
                                    }, {
                                        validator: this.checkEmail
                                    }],
                                })(
                                    <Input onChange={this.handleConfirmBlur} />
                                    )}
                            </FormItem>
                             */}
                                <FormItem
                                    {...formItemLayout}
                                    label="Employer"
                                >
                                    {getFieldDecorator('emp', {
                                        initialValue: this.currentEmployer,
                                        rules: [{
                                            required: true, message: 'Please select an employer!'
                                        }],
                                    })(
                                        <Select
                                            showSearch
                                            style={{ width: '75%' }}
                                            searchPlaceholder="Enter Company Name"
                                            optionFilterProp="children"
                                            onChange={this.getEmployerId}
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        >
                                            {this.employerDisplayList}
                                        </Select>)}
                                </FormItem>
                                <FormItem {...tailFormItemLayout} >
                                    {/* <button type="submit" className="btn btn-default" onClick={() => { this.props.updateEvent(); }} >Cancel</button> */}
                                    <button type="submit" className="btn btn-default" onClick={event => window.location.href = '#/admin/editattendee'} >Back</button>
                                    <button type="submit" className="btn btn-default" style={{ margin: 5 }}>Update</button>
                                </FormItem>
                            </div>
                        </Form>
                    </Spin>
                    : <Redirect to="/login" replace />
                }
            </div>
        );
    }

    getDateOfBirthNew = (date) => {
        this.props.form.setFieldsValue({
            ['dob']: date,
        });

    }

    handleClassEmployer = (value) => {

        console.log(value);

    }

    getEmployerId = (value) => {
        this.handleChangeEmployer;
        this.setState({
            id: value
        });
    }

}

const WrappedAddClassesForm = Form.create()(EditStudentForm);

export default WrappedAddClassesForm;


// WEBPACK FOOTER //
// ./src/Admin/EditStudentForm.js